/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
/**
 * @desc 审批语言包
 * @author zhaolun
 * @date 2023年10月26日16:38:06
 */
export default {
  审批管理: 'Approve Manage',
  新增: 'Add',
  '请选择/输入值': 'Please select/enter a value',
  请选择规则: 'Please select rule',
  审批事件名称: 'Approve name',
  流程名称: 'Process Name',
  流程描述: 'Process Description',
  触发对象: 'Trigger Object',
  请选择触发对象: 'Please select the triggering object',
  触发按钮: 'Trigger button',
  审批归属人: 'Requester',
  请选择审批归属人: 'Please select the requester',
  触发条件: 'Trigger conditions',
  请设置触发条件: 'Please set triggering conditions',
  审批流程名称: 'Approval process name',
  审批描述: 'Approve description',
  审批触发的按钮: 'Trigger buttons',
  弃用状态: 'Deprecated state',
  请输入审批流程名称: 'Please enter the name of the approval process',
  设置审批分支: 'Set approve branch',
  '请输入（可填写用途或备注说明）': 'Please input (can be used for purpose or remark)',
  分支: 'Branch',
  触发审批条件: 'Trigger approve condition',
  审批Code: 'Approve code',
  请输入审批Code: 'Please input approve code',
  审批模板: 'Approval template',
  请选择审批模板: 'Please select an approval template',
  关联接口映射规则: 'Api mapping rule',
  请选择关联接口映射规则: 'Please select api mapping rule',
  映射规则: 'Api mapping rule',
  请选择映射规则: 'Please select api mapping rule',
  请设置: 'Please set',
  新增审批事件: 'Add Approve',
  编辑审批流程: 'Edit Approve',
  请选择关联对象: 'Please select related object',
  触发审批的按钮: 'Trigger approve button',
  请选择触发审批的按钮: 'Please select trigger approve button',
  启用状态: 'State',
  添加分支: 'Add Branch',
  请完善请求参数: 'Please complete request parameters',
  字段已停用: 'The field has been disabled',
  对象已停用: 'The object has been disabled',
  '发起审批后，飞书侧飞书审批的实际提交人。': 'The actual person who submitted the approval instance via the Lark API.',
  '烽火侧发起审批的实际操作人（与审批归属人可能非同一人员）。': 'The user in the Matrix system who performed this action.',
  已停用: 'Disabled',
  '（）': '({0})'
};
